export const RoutePath = {
  auth: {
    login: 'auth/login',
    signup: 'auth/signup',
    forgot: 'auth/forgot-password',
  },
  error: {
    e404: 'error/404',
    e500: 'error/500',
  },
  dashboard: '/service/dashboard',
  callLogs: '/service/call-log',
  callTrace: '/service/settings/call-trace',
  user: {
    users: '/service/user',
    add: '/service/user/add/:id',
    edit: '/service/user/edit/:id',
    addApiKey: '/service/user/edit/:id/addapikey',
    editkey: '/service/user/edit/:id',
    delete: '/service/user/delete/:id/editkey/:id',
    deletekey: '/service/user/delete/:id/deletekey/:id',
    account: '/service/user/account',
  },
  billing: {
    profile: '/service/billing',
    settings: '/service/billing/settings',
    product: '/service/products',
  },
  product: {
    products: '/service/products',
  },
  systemSetting: {
    systemSettings: '/service/systemSettings',
  },
  receiving: {
    numbers: '/service/routing/receiving',
    extensions: '/service/routing/extensions',
    sipgateways: '/service/routing/sipgateway',
    whitelist: '/service/routing/whitelist',
  },
  numberman: {
    management: '/service/numberman',
    add: '/service/numberman/add',
    edit: '/service/numberman/edit/:id',
    delete: '/service/numberman/delete/:id',
  },
  tracking_number: {
    numbers: '/service/tracking-number',
    setup: '/service/tracking-number/setup',
    add: '/service/tracking-number/add',
    edit_full: '/service/tracking-number/edit/',
    edit: '/service/tracking-number/edit/:id',
    delete_full: '/service/tracking-number/delete/',
    delete: '/service/tracking-number/delete/:id',
  },
  tracking_source: {
    sources: '/service/tracking-source',
    add: '/service/tracking-source/add',
    edit: '/service/tracking-source/:id',
  },
  reports: {
    activity_reports: '/service/reports/activity',
    roi_reports: '/service/reports/roi',
    overview: '/service/reports/overview',
  },
  customer: {
    customers: '/service/customer',
    users: '/service/customer/:id/users',
    add: '/service/customer/add/:id',
    edit: '/service/customer/edit/:id',
    delete: '/service/customer/delete/:id',
  },
  customer_panel: {
    customer_panel: '/service/customer-panel',
  },
  role: {
    roles: '/service/role',
    add: '/service/role/add/:id',
    edit: '/service/role/edit/:id',
    delete: '/service/role/delete/:id',
  },
  system: {
    dialogs: '/service/system/calls',
    audit: '/service/system/audit',
    emailSignups: '/service/system/email-signups',
  },
  ivr: '/service/ivr',
};

export const AppRoutes = {
  Customer: RoutePath.customer.customers,
  CustomerPanel: RoutePath.customer_panel.customer_panel,
  Billing: RoutePath.billing.settings,
  Dashboard: RoutePath.dashboard,
  Role: RoutePath.role.roles,
  Overview: RoutePath.reports.overview,
  CallLogs: RoutePath.callLogs,
  User: RoutePath.user.account,
  NumbersManagement: RoutePath.numberman.management,
  TrackingNumbers: RoutePath.tracking_number.numbers,
  ReceivingNumbers: RoutePath.receiving.numbers,
  TrackingSources: RoutePath.tracking_source.sources,
  ActivityReports: RoutePath.reports.activity_reports,
  SipGateways: RoutePath.receiving.sipgateways,
};
